import React from 'react'

import {
  Button,
  Flex,
  Icon,
  IconProps,
  Inline,
  Text,
  Variant,
  useBreakpoints,
} from '@procsea/design-system'

import { UINotification } from 'src/types'

import { Banner, MenuOverlap, NotificationsContainer } from './Notifications.styles'

const getCorrectIcon = (type: UINotification['type']): IconProps['name'] => {
  switch (type) {
    case 'informative':
      return 'info-circle'
    case 'positive':
      return 'check-circle'
    case 'negative':
      return 'exclamation-triangle'
    default:
      return 'check'
  }
}
const getCorrectColor = (type: UINotification['type']): Variant => {
  switch (type) {
    case 'informative':
      return 'primary'
    case 'positive':
      return 'success'
    case 'negative':
      return 'danger'
    default:
      return 'success'
  }
}

const FOUR_SECONDS_NOTIFICATION = 4000

export interface NotificationsProps {
  notifications: UINotification[]
  handleNotificationClose: (uuid: string) => void
}

const Notifications = ({ notifications = [], handleNotificationClose }: NotificationsProps) => {
  const { isDesktop } = useBreakpoints()

  if (notifications.length === 0) return null

  return (
    <NotificationsContainer data-e2e="notifications-container">
      <Flex>
        {isDesktop && <MenuOverlap />}

        {notifications.map(notification => {
          if (notification.type === 'positive')
            setTimeout(() => handleNotificationClose(notification.id), FOUR_SECONDS_NOTIFICATION)

          return (
            <Banner
              key={notification.id}
              inset="xsmall"
              variant={getCorrectColor(notification.type)}
            >
              <Flex alignment="center" fluid>
                <Inline alignment="center" spacing="medium">
                  <Icon faStyle="fas" name={getCorrectIcon(notification.type)} variant="white" />

                  <Text bold size="large" data-e2e="notification-message" variant="white">
                    {notification.message}
                  </Text>
                </Inline>

                <Button
                  icon="times"
                  data-e2e="notification-close"
                  onClick={() => handleNotificationClose(notification.id)}
                  text
                  variant="white"
                />
              </Flex>
            </Banner>
          )
        })}
      </Flex>
    </NotificationsContainer>
  )
}

export default Notifications
